<template>
    <div>
        <v-list dense>
            <template v-for="item in items">
                <v-list-item
                    v-if="!item.requiresAdmin || item.requiresAdmin && authUser.isAdmin"
                    :key="item.text"
                    link
                    :to="{name: item.toUrlName}"
                    exact
                >
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>

    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: 'AppMenu',
    props: {
      source: String,
    },
    data: () => ({
        dialog: false,
        drawer: null,
        items: [
            { icon: 'mdi-content-copy', text: 'Facturas', toUrlName: 'home', requiresAdmin: false },
            { icon: 'mdi-account-cog-outline', text: 'Usuarios', toUrlName: 'usuarios', requiresAdmin: true }
        ]
    }),
    methods: {
    },
    mounted() {
        // console.log(this.authUser);
    },
    computed:{
        ...mapState("login", ["authUser"])
    }
}
</script>